<template>
    <div class="mmr">
        <my-header :title="title" :platform="platform"></my-header>
        <!-- <embed src="https://www.koalaknow.com/img/guize.pdf#toolbar=0&navpanes=0&scrollbar=0"  width="100%" height="100%" fullscreen="yes"  wmode="transparent" style="background: #fff;" bgcolor="#ffffff"/> -->
        
        <div v-if="taskId==2">
            <img src="/static/mymission/rule1.jpg" class="img">
            <img src="/static/mymission/rule2.jpg" class="img">
            <img src="/static/mymission/rule3.jpg" class="img">
            <img src="/static/mymission/rule4.jpg" class="img">
        </div>
        <div v-else>
            <img src="/static/mymission/daily1.jpg" class="img">
            <img src="/static/mymission/daily2.jpg" class="img">
            <img src="/static/mymission/daily3.jpg" class="img">
            <img src="/static/mymission/daily4.jpg" class="img">
            <img src="/static/mymission/daily5.jpg" class="img">
        </div>
        
        
    </div>
</template>
<script>
import MyHeader from "../common/MyHeader/MyHeader"
export default {
    name:'MyMissonRule',
    data(){
        return {
            taskId:'',
            title:'',
            platform:''
        }
    },
    components:{
        MyHeader
    },
    created(){
        this.taskId=this.$route.query.taskId
        this.title=this.taskId==1?'任务打卡':'日常分享'
        this.platform=this.$route.query.platform
    }
}
</script>
<style scoped>

.img{
    width: 100%;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/content/MyMissionRule.vue